module.exports = __webpack_public_path__ + "img/side_zipper_length.053b516e.png";